module.exports = __webpack_public_path__ + "img/logoblanco.28dec026.png";